import { ReporteEstadoPolizaModel } from "../../_services/model-poliza/reporteEstadoPolizaModel";

export class ReportePoliza implements ReporteEstadoPolizaModel {
    fecha;    
    codEstado?: number;
    codSucursal?: number;
    codTipoMovimiento?: number;
    codRamo?: number;
    brokerId?: any;
  }